import { Constants } from '../_constants/constants';

export class ResetPasswordParametersDto {
    token: string;
    username: string;
    newPassword: string;
    confirmNewPassword: string;
    recaptchaToken: string;
    portalType = Constants.portalType;
}
